import React from "react";
import { Query, Mutation } from "react-apollo";
import {
  Divider,
  Row,
  Col,
  Card,
  Button,
  Popconfirm,
  message,
  Spin
} from "antd";
import moment from "moment";

import GetOrderPartner from "../../GraphQL/Query/GetOrderPartner";
import OrderFile from "./OrderFile";
import ConfirmOrderResponse from "../../GraphQL/Mutation/ConfirmOrderResponse";
import GetOrder from "../../GraphQL/Query/GetOrder";

class OrderResponse extends React.Component {
  handleConfirmOrderResponse = mutate => {
    const { orderId, user } = this.props;

    mutate({
      variables: { orderId, userId: user.username },
      refetchQueries: [
        { query: GetOrder, variables: { orderId, userId: user.username } }
      ],
      update: (proxy, { data: { confirmOrderResponse } }) => {
        const query = GetOrder;
        const variables = { orderId, userId: user.username };
        const data = proxy.readQuery({
          query,
          variables
        });

        proxy.writeQuery({ query, data });
      }
    })
      .then(() => {
        message.success("¡Actualizado correctamente!");
      })
      .catch(err => {
        message.error(err.message);
      });
  };

  render() {
    const { order, orderId } = this.props;
    const { serviceTitle } = order;
    return (
      <Query
        query={GetOrderPartner}
        variables={{ orderId, userId: order.partnerAssignedId }}
        fetchPolicy="cache-and-network"
      >
        {({ loading, error, data }) => {
          if (loading) return <Spin />;
          if (error) return <p>Error :(</p>;
          const { getOrderPartner: orderPartner = {} } = data;
          //console.log(orderPartner);
          return (
            <Mutation mutation={ConfirmOrderResponse}>
              {mutate => (
                <Row gutter={32}>
                  <Row>
                    <h2>Respuesta de la orden enviada por el partner</h2>
                    <p>{serviceTitle}</p>
                    <Divider />
                  </Row>
                  <Row gutter={16}>
                    <Col md={24} xl={8} style={{ paddingBottom: 12 }}>
                      <Card
                        title="Archivos generados"
                        bordered
                        style={{ boxShadow: "var(--shadow-super-light)" }}
                      >
                        {/* <div className="order-response-files-list"> */}
                        {orderPartner.files && orderPartner.files.length
                          ? orderPartner.files.map(file => (
                              <OrderFile key={file.key} file={file} />
                            ))
                          : "No hay archivos"}
                        {/* </div> */}
                      </Card>
                    </Col>
                    <Col md={24} xl={8} style={{ paddingBottom: 12 }}>
                      <Card
                        title="Comentarios del partner"
                        bordered
                        style={{ boxShadow: "var(--shadow-super-light)" }}
                      >
                        {orderPartner.comments}
                      </Card>
                    </Col>
                    <Col md={24} xl={8} style={{ paddingBottom: 12 }}>
                      <Card
                        title="Última actualización"
                        bordered
                        style={{ boxShadow: "var(--shadow-super-light)" }}
                      >
                        {moment(orderPartner.updatedAt).format("LLL")}
                      </Card>
                    </Col>
                    <Col md={24} xl={8} style={{ paddingBottom: 12 }}>
                      <Card
                        title="Confirmar orden"
                        bordered
                        style={{ boxShadow: "var(--shadow-super-light)" }}
                      >
                        <div>
                          <p>
                            Si estás satisfecho con tu orden por favor confirma
                            la terminación del servicio. De lo contrario da
                            seguimiento en el chat.
                          </p>
                          <Popconfirm
                            title="¿Confirmar entrega del servicio?"
                            onConfirm={() =>
                              this.handleConfirmOrderResponse(mutate)
                            }
                            onCancel={() => null}
                            okText="Confirmar"
                            cancelText="Cancelar"
                          >
                            <Button
                              // onClick={event =>
                              //   this.handleConfirmOrderResponse(mutate, event)
                              // }
                              className="button-inline response"
                              type="primary"
                            >
                              Confirmar orden
                            </Button>
                          </Popconfirm>
                        </div>
                      </Card>
                    </Col>
                  </Row>
                </Row>
              )}
            </Mutation>
          );
        }}
      </Query>
    );
  }
}

export default OrderResponse;



// WEBPACK FOOTER //
// ./src/Components/Orders/OrderResponse.js